// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  height: calc(100vh - (var(--header-height) + var(--toolbar-height)));
}

.admin-content {
  padding-inline: 1rem;
  padding-block: 0.5rem;
  height: calc(100vh - (var(--header-height) + var(--toolbar-height)) - 1rem);
}

.admin-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  padding: 1rem;
  height: 100%;
}

.device-list mat-table {
  border-collapse: collapse;
}

mat-header-cell,
th {
  font-weight: 600;
}

mat-header-cell,
mat-cell,
th,
td {
  padding: 14px 16px;
  text-align: left;
}

.inline-form-field {
  width: 100%;
  margin: -4px 0;
}
.inline-form-field ::ng-deep .mat-mdc-form-field-flex {
  height: 44px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/admin/admin.component.scss"],"names":[],"mappings":"AAMA;;EAEI,oEAJe;AADnB;;AAQA;EAEI,oBAAA;EACA,qBAFgB;EAGhB,2EAAA;AANJ;;AASA;EACI,aAAA;EACA,8BAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;AANJ;;AASA;EAEI,yBAAA;AAPJ;;AAUA;;EAEI,gBAAA;AAPJ;;AAUA;;;;EAII,kBAAA;EACA,gBAAA;AAPJ;;AAUA;EACI,WAAA;EACA,cAAA;AAPJ;AASI;EACI,YAAA;AAPR","sourcesContent":["$border-color: blue;\n$border-color-hover: green;\n\n$parent-height: calc(var(--header-height) + var(--toolbar-height));\n$component-height: calc(100vh - $parent-height);\n\nhtml,\nbody {\n    height: $component-height;\n}\n\n.admin-content {\n    $padding-block: 0.5rem;\n    padding-inline: 1rem;\n    padding-block: $padding-block;\n    height: calc($component-height - ($padding-block * 2));\n}\n\n.admin-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1rem;\n    padding: 1rem;\n    height: 100%;\n}\n\n.device-list mat-table {\n    // width: 50%;\n    border-collapse: collapse;\n}\n\nmat-header-cell,\nth {\n    font-weight: 600;\n}\n\nmat-header-cell,\nmat-cell,\nth,\ntd {\n    padding: 14px 16px;\n    text-align: left;\n}\n\n.inline-form-field {\n    width: 100%;\n    margin: -4px 0;\n\n    ::ng-deep .mat-mdc-form-field-flex {\n        height: 44px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
